import React from 'react'
import { useErrorHandler } from 'react-error-boundary'
import { useRouter } from 'next/router'

import DocumentActionFooter from 'app/DocumentCollectionPage/components/DocumentActionFooter'
import Header from 'app/DocumentCollectionPage/components/Header'
import { getCustomErrorByStatus } from 'app/DocumentCollectionPage/utils/customError'
import { PDFViewer } from 'components/PDFViewer'
import { useSETrackEvent } from '../hooks/useSETrackEvent'

import type { TDocument } from 'types/document-collection'

interface IDocumentDetailPageProps {
  data: TDocument
  errorCode?: number
}
const DocumentDetailPage: React.FC<IDocumentDetailPageProps> = ({
  data,
  errorCode,
}) => {
  const router = useRouter()
  const { SETrackDocumentLandingPage } = useSETrackEvent()
  const handleError = useErrorHandler()

  if (Boolean(errorCode) || Object.keys(data).length === 0) {
    const path = '/dokumen/:id'
    const error = new Error('Page is not available')
    const unhandledError = getCustomErrorByStatus(errorCode, path, error)

    handleError(unhandledError)
    return null
  }

  return (
    <>
      {/* eslint-disable react/no-unknown-property */}
      <style jsx global>
        {`
          #document-detail-page .pdfLoader {
            margin: auto;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
          }
        `}
      </style>
      <div id="document-detail-page" className="h-screen max-w-xl mx-auto">
        <Header
          icon="close"
          title={data?.title}
          headerLeftOnClick={() => {
            SETrackDocumentLandingPage(
              'CLICK_KUMPULAN_DOKUMEN_CLOSE_DOCUMENT',
              {
                screen_name: 'KUMPULAN_DOKUMEN_DOCUMENT_PAGE',
                event_trigger: 'KUMPULAN_DOKUMEN_DOCUMENT_PAGE',
                parent_category: router?.query?.parentCategory,
                category: data?.categoryName,
                title: data?.title,
                content_id: data?.id,
                url: `${window.location.origin}${window.history.state.as}`,
              }
            )
          }}
        />

        <main className="flex items-center justify-center mt-14">
          <div className="w-full max-w-xl pb-16 mb-2">
            {Boolean(data?.documentUrl) && (
              <PDFViewer url={data?.documentUrl} />
            )}
          </div>

          {Boolean(data?.documentUrl) && <DocumentActionFooter data={data} />}
        </main>
      </div>
    </>
  )
}

export default DocumentDetailPage
